export default "__VITE_ASSET__gpMdTEJ9__"